<script setup lang="ts">
import type { Schemas } from "#shopware";
import { getTranslatedProperty } from "@shopware/helpers";

const { properties } = defineProps<{
	properties: Schemas["PropertyGroupOption"][];
}>();

const groupedProperties = computed(() => {
	return properties.reduce(
		(groups, property) => {
			const group = groups.find((group) => group.name === property.group.name);
			if (group) {
				group.properties.push(getTranslatedProperty(property, "name"));
				return groups;
			}

			groups.push({
				name: property.group.name,
				properties: [getTranslatedProperty(property, "name")]
			});
			return groups;
		},
		[] as { name: string; properties: string[] }[]
	);
});
</script>

<template>
	<div class="flex flex-col gap-4 text-sm">
		<div class="flex flex-col" v-for="group in groupedProperties" :key="group.name">
			<span class="font-bold">{{ group.name }}</span>
			{{ group.properties.join(", ") }}
		</div>
		<slot />
	</div>
</template>
